import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { AffCodeService } from 'src/app/affcode/shared/affcode.service';
import { EcomItemDto } from '../shared/dto/ecom-item.dto';
import { EcomService } from '../shared/ecom.service';

@Component({
  selector: 'wl-ecom-item-edit-affcodes',
  templateUrl: './ecom-item-edit-affcodes.component.html',
  styleUrls: ['./ecom-item-edit-affcodes.component.less'],
    standalone: false
})
export class EComItemEditAffCodesComponent implements OnInit, OnChanges {
  @Input() eCommerceItem: EcomItemDto;
  allAffCodes: string[];
  affCodeSearchResults: string[];
  selectedAffCodes: string[] = [];
  affCodesToDelete: string[] = [];

  @Output() affCodeChanged = new EventEmitter<EcomItemDto>();
  constructor(private _ecomService: EcomService, private _affCodeService: AffCodeService) {}

  ngOnInit(): void {
    this._affCodeService.getAllAffCodes().then((affCodes) => {
      this.allAffCodes = affCodes?.map((x) => x.AffCode)
    });
  }

  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    if (changes.eCommerceItem) {
      this._affCodeService.getAllAffCodes().then((affCodes) => {
        this.allAffCodes = affCodes?.map((x) => x.AffCode);
      });
      this.selectedAffCodes = this.eCommerceItem.AffCodesToAdd ?? [];
    }
  }

  updateAffCodes() {
    this.affCodeChanged.emit(this.eCommerceItem);
  }

  searchAffCodes(searchEvent: any) {
    this.affCodeSearchResults = this.allAffCodes
      ?.filter((ac) => ac.toLowerCase().includes(searchEvent.query?.toLowerCase()))
      .filter((x) => !this.selectedAffCodes?.find((y) => x === y));
  }

  addAffCode(affCode: string) {
    if (!this.eCommerceItem.AffCodesToAdd) {
      this.eCommerceItem.AffCodesToAdd = [];
    }
    this.eCommerceItem.AffCodesToAdd.push(affCode);
    this.updateAffCodes();
  }

  deleteAffCode(affCode: string) {
    const ecomItemAffCode = this.eCommerceItem.AffCodesToAdd?.find((x) => x === affCode);
    if (ecomItemAffCode) {
      const index = this.eCommerceItem.AffCodesToAdd.findIndex((x) => x === ecomItemAffCode);
      this.eCommerceItem.AffCodesToAdd.splice(index, 1);
      this.updateAffCodes();
    }
  }
}
